





















































import Vue from "vue";
import store from "@/store";
import firebaseApp from "@/main";

export default Vue.extend({
  data: () => ({
    valid: false,
    overlayLoader: false,
    // Email Validation
    email: "",
    emailRules: [
      (v: any) => !!v || "E-mail is required",
      (v: any) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    // Password Validation
    password: "",
    showPassword: false,
    passwordRules: {
      required: (value: any) => !!value || "Required.",
      min: (v: any) => v.length >= 6 || "Min 6 characters",
    },
  }),
  mounted() {
    if (store.getters["userStore/isUserSignedIn"]) this.$router.push("/");
  },
  methods: {
    async signIn() {
      if (this.valid) {
        this.overlayLoader = true;
        await firebaseApp
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(async (authResult) => {
            store.commit("userStore/setUserUID", authResult.user?.uid);
            await firebaseApp
              .firestore()
              .collection("users")
              .doc(authResult.user?.uid)
              .get()
              .then((docData) => {
                store.commit("setUserData", docData.data());
                this.$router.push("/workout");
                this.overlayLoader = false;
              });
          })
          .catch((err) => {
            console.error(err);
            if (err.code === "auth/wrong-password") alert("Wrong Password");
            else if (err.code === "auth/user-not-found")
              alert("No email found");
            else alert("there was a problem on our side");
            this.overlayLoader = false;
          });
      } else alert("Make sure your form is correct. ");
    },
    sendToForgotPassword() {
      this.$router.push("/forgotPassword");
    },
  },
});
